import dynamic from 'next/dynamic';
import { ConfirmationMessageProps } from './ConfirmationMessage.types';

export const ConfirmationMessage = dynamic<ConfirmationMessageProps>(() => import('./ConfirmationMessage'));
